import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.jpeg";
import {
  CategoryIcon,
  Logout,
  NewsIcon,
  ProductsIcon,
  Star,
} from "../../assets/images/icons";
import "./sidebar.scss";
import { useState } from "react";
import Loader from "../loading";
import {
  FolderDot,
  HandPlatter,
  Network,
  ShoppingCart,
  TicketSlash,
} from "lucide-react";

const Sidebar = () => {
  const currentPath = window.location.pathname;
  console.log(currentPath, "pathname");
  const navigate = useNavigate();

  const handleHardRefresh = () => {
    // Append a random query parameter to the URL
    const randomQueryParam = `?random=${Math.random()}`;
    window.location.href = window.location.href + randomQueryParam;
  };

  const pageChanger = () => {
    // 2 sekundlik kechikishni o'rnatish
    localStorage.setItem("page", JSON.stringify(1));
    // handleHardRefresh();
  };

  return (
    <div className="sidebar">
      {/* {isLoading && <Loader/>} */}
      <div>
        <div className="sidebar-top">
          <div className="sidebar-logo">
            <Link onClick={() => navigate("/admin/news")} to={"/admin/news"}>
              <img
                style={{ borderRadius: "50%" }}
                width={120}
                height={120}
                src={Logo}
                alt=""
              />
            </Link>
          </div>
          <div className="menu">
            <button
              onClick={() => {
                navigate("/admin/news");
                pageChanger();
              }}
              className={currentPath === "/admin/news" ? "link active" : "link"}
            >
              <NewsIcon />
              Yangiliklar
            </button>
            <button
              onClick={() => {
                navigate("/admin/products");
                pageChanger();
              }}
              className={
                currentPath === "/admin/products" ? "link active " : "link"
              }
            >
              <ProductsIcon />
              Mahsulotlar
            </button>
            <button
              onClick={() => {
                navigate("/admin/bigprojects");
                pageChanger();
              }}
              className={
                currentPath === "/admin/bigprojects" ? "link active " : "link"
              }
            >
              <FolderDot size={17} /> Yirik loyihalar
            </button>
            <button
              onClick={() => {
                navigate("/admin/services");
                pageChanger();
              }}
              className={
                currentPath === "/admin/services" ? "link active " : "link"
              }
            >
              <HandPlatter size={17} /> Servislar
            </button>
            <button
              onClick={() => {
                navigate("/admin/category");
                pageChanger();
              }}
              className={
                currentPath === "/admin/category" ? "link active " : "link"
              }
            >
              <CategoryIcon />
              Kategoriyalar
            </button>

            <button
              onClick={() => {
                navigate("/admin/partners");
                pageChanger();
              }}
              className={
                currentPath === "/admin/partners" ? "link active " : "link"
              }
            >
              <Network size={17} />
              Partnerlar
            </button>
            <button
              onClick={() => {
                navigate("/admin/banners");
                pageChanger();
              }}
              className={
                currentPath === "/admin/banners" ? "link active " : "link"
              }
            >
              <TicketSlash size={17} /> Bannerlar
            </button>
            <button
              onClick={() => {
                navigate("/admin/orders");
                pageChanger();
              }}
              className={
                currentPath === "/admin/orders" ? "link active " : "link"
              }
            >
              <ShoppingCart size={17} /> Buyurtmalar
            </button>
          </div>
        </div>
        <div className="sidebar-bottom">
          <Link onClick={() => localStorage.removeItem("token")} to={"/"}>
            <Logout />
            Chiqib ketish 
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Sidebar;
